import { Action } from '@ngrx/store';
import * as Model from 'src/store/workspace/workspace.model';
import { TimeSummaryRow } from 'src/store/workspace/workspace.model';
import { SortDescriptor } from '@progress/kendo-data-query';

export enum WorkspaceActionTypes {
    SET_SEARCH_BY_DATE_OPTION = '[WORKSPACE] Set Search By Date Option',
    LOAD_PAY_PERIODS = '[WORKSPACE] Load Pay Periods',
    LOAD_CLIENTS = '[WORKSPACE] Load Clients',
    SET_CLIENTS = '[WORKSPACE] Set Clients',
    SET_PAY_PERIODS = '[WORKSPACE] Set Pay Periods',
    SELECT_PAY_PERIOD = '[WORKSPACE] Select Pay Period',
    SELECT_CLIENT = '[WORKSPACE] Select Client',
    SELECT_STAFF = '[WORKSPACE] Select Staff',
    SET_SELECTED_STAFF_ID = '[WORKSPACE] Set Selected Staff ID',
    LOAD_STAFF = '[WORKSPACE] Load Staff',
    LOAD_STAFF_CODES = '[WORKSPACE] Load Staff Codes',
    SET_STAFF_CODES = '[WORKSPACE] Set Staff Codes',
    LOAD_TIMESHEETS = '[WORKSPACE] Load Timesheets',
    SEARCH = '[WORKSPACE] Search',
    SET_TIMESHEETS = '[WORKSPACE] Set Timesheets',
    SAVE_TIMESHEET = '[WORKSPACE] Save Timesheet',
    SAVE_TIMESHEET_SUCCESS = 'Timesheet Successfully Saved',
    SET_DESCRIPTIONS = '[WORKSPACE] Set Descriptions',
    LOAD_DESCRIPTIONS = '[WORKSPACE] Load Descriptions',
    SEND_NOTIFICATION = '[WORKSPACE] Send Message',
    ADD_ALERT = '[WORKSPACE] Add Alert',
    REMOVE_ALERT = '[WORKSPACE] Remove Alert',
    REMOVE_NOTIFICATION = '[WORKSPACE] Remove Message',
    ADD_TIMESHEET = '[WORKSPACE] Add Timesheet',
    DELETE_TIMESHEET = '[WORKSPACE] Delete Timesheet',
    DELETE_TIMESHEET_SUCCESS = 'Timesheet Successfully Deleted',
    LOAD_SUMS = '[WORKSPACE] Load Sums',
    SET_VIEW = '[WORKSPACE] Toggle View',
    LOAD_UNSUBMITTED_SUMMARY = '[WORKSPACE] Load Unsubmitted Summary',
    SET_UNSUBMITTED_SUMMARY_ROWS = '[WORKSPACE] Set Unsubmitted Summary Rows',
    SET_SUMMARY_ROWS = '[WORKSPACE] Set Summary Rows',
    SUBMIT_SUMMARY_ROW = '[WORKSPACE] Submit Summary Row',
    UPDATE_SUMMARY_ROW = '[WORKSPACE] Update Summary Row',
    UNDO_TIMESHEET_SUMMARY_ROW = '[WORKSPACE] Undo Timesheet Summary Row',
    UNDO_SUMMARY_ROW = '[WORKSPACE] Undo Summary Row',
    LOAD_SUMMARIES = '[WORKSPACE] Load Summaries',
    LOAD_PTO = '[WORKSPACE] Load Paid Time Off',
    SET_PTO = '[WORKSPACE] Set Paid Time Off',
    SELECT_DATE_RANGE = '[WORKSPACE] Select Date Range',
    SET_LOADING = '[WORKPSACE] Set Loading',
    SET_PAGE_SIZE = '[WORKSPACE] Set Page Size',
    LOAD_PAGE_SIZE = '[WORKSPACE] Load Page Size',
    SET_SUMMARIES_PAGE_SIZE = '[WORKSPACE] Set Summaries Page Size',
    LOAD_SUMMARIES_PAGE_SIZE = '[WORKSPACE] Load Summaries Page Size',
    SET_SORT = '[WORKSPACE] Set Sort',
    LOAD_ALERTS = '[WORKSPACE] Load Alerts',
    SET_STAFF_LIST = '[WORKSPACE] Set Staff List',
    SELECT_STAFF_SEARCH = '[WORKSPACE] Select Staff For Search',
    LOAD_CATEGORIES = '[WORKSPACE] Load Categories',
    SET_CATEGORIES = '[WORKSPACE] Set Categories',
    ADD_CATEGORY = '[WORKSPACE] Add Category',
    SET_CATEGORIES_PAGE_SIZE = '[WORKSPACE] Set Categories Page Size',
    LOAD_CATEGORIES_PAGE_SIZE = '[WORKSPACE Load Categories Page Size',
    ADD_DESCRIPTION = '[WORKSPACE] Add Description',
    SET_DESCRIPTIONS_PAGE_SIZE = '[WORKSPACE] Set Descriptions Page Size',
    LOAD_DESCRIPTIONS_PAGE_SIZE = '[WORKSPACE] Load Descriptions Page Size',
    UPDATE_DESCRIPTION = '[WORKSPACE] Update Description',
    SELECT_CATEGORY_FOR_SEARCH = '[WORKSPACE] Select Category For Search',
    SET_CLIENTS_PAGE_SIZE = '[WORKSPACE] Set CLIENTS Page Size',
    LOAD_CLIENTS_PAGE_SIZE = '[WORKSPACE Load CLIENTS Page Size',
    DELETE_CLIENT = '[WORKSPACE] Delete Client',
    ADD_CLIENT = '[WORKSPACE] Add Client',
    UPDATE_CLIENT = '[WORKSPACE] Update Client',
    SET_STAFF_PAGE_SIZE = "[WORKSPACE] Set Staff Page Size",
    LOAD_STAFF_PAGE_SIZE = "[WORKSPACE] Load Staff Page Size",
    DELETE_STAFF = "[WORKSPACE] Delete Staff",
    ADD_STAFF = "[WORKSPACE] Add Staff",
    UPDATE_STAFF = "[WORKSPACE] Update Staff",
    SET_STAFFS = "[WORKSPACE] Set Staffs",
    LOAD_STAFFS = "[WORKSPACE] Load Staffs"
}

export class SetSearchByDateOption implements Action {
    readonly type = WorkspaceActionTypes.SET_SEARCH_BY_DATE_OPTION;
    constructor(public payload: Model.SearchDateOptions) {}
}

export class LoadPayPeriods implements Action {
    readonly type = WorkspaceActionTypes.LOAD_PAY_PERIODS;
}

export class LoadClients implements Action {
    readonly type = WorkspaceActionTypes.LOAD_CLIENTS;
}

export class SetClients implements Action {
    readonly type = WorkspaceActionTypes.SET_CLIENTS;
    constructor(public payload: Model.ClientDTO[]) {}
}

export class SetPayPeriods implements Action {
    readonly type = WorkspaceActionTypes.SET_PAY_PERIODS;
    constructor(public payload: Model.PayPeriodDTO[]) {}
}

export class SelectPayPeriod implements Action {
    readonly type = WorkspaceActionTypes.SELECT_PAY_PERIOD;
    constructor(public payload?: Model.PayPeriod) {}
}

export class SelectClient implements Action {
    readonly type = WorkspaceActionTypes.SELECT_CLIENT;
    constructor(public payload: Model.ClientDTO) {}
}

export class SelectStaff implements Action {
    readonly type = WorkspaceActionTypes.SELECT_STAFF;
    constructor(public payload: Model.StaffDTO) {}
}

export class LoadStaff implements Action {
    readonly type = WorkspaceActionTypes.LOAD_STAFF;
}

export class LoadStaffCodes implements Action {
    readonly type = WorkspaceActionTypes.LOAD_STAFF_CODES;
}

export class SetStaffCodes implements Action {
    readonly type = WorkspaceActionTypes.SET_STAFF_CODES;
    constructor(public payload: Model.StaffCodeDTO[]) {}
}

export class SetSelectedStaffID implements Action {
    readonly type = WorkspaceActionTypes.SET_SELECTED_STAFF_ID;
    constructor(public payload: number) {}
}

export class LoadTimesheets implements Action {
    readonly type = WorkspaceActionTypes.LOAD_TIMESHEETS;
}

export class Search implements Action {
    readonly type = WorkspaceActionTypes.SEARCH;
}

export class SetTimesheets implements Action {
    readonly type = WorkspaceActionTypes.SET_TIMESHEETS;
    constructor(public payload: Model.TimeSheet[]) {}
}

export class SaveTimesheet implements Action {
    readonly type = WorkspaceActionTypes.SAVE_TIMESHEET;
    constructor(public payload: Model.TimeSheet) {}
}

export class SaveTimesheetSuccess implements Action {
    readonly type = WorkspaceActionTypes.SAVE_TIMESHEET_SUCCESS;
    constructor(public payload: Model.TimeSheet) {}
}

export class SetDescriptions implements Action {
    readonly type = WorkspaceActionTypes.SET_DESCRIPTIONS;
    constructor(public payload: Model.Description[]) {}
}

export class LoadDescriptions implements Action {
    readonly type = WorkspaceActionTypes.LOAD_DESCRIPTIONS;
}

export class SendMessage implements Action {
    readonly type = WorkspaceActionTypes.SEND_NOTIFICATION;
    constructor(public payload: Model.Message) {}
}

export class RemoveMessage implements Action {
    readonly type = WorkspaceActionTypes.REMOVE_NOTIFICATION;
}

export class AddTimesheet implements Action {
    readonly type = WorkspaceActionTypes.ADD_TIMESHEET;
    constructor(public payload: Model.TimeSheet) {}
}

export class DeleteTimesheet implements Action {
    readonly type = WorkspaceActionTypes.DELETE_TIMESHEET;
    constructor(public payload: Model.TimeSheet) {}
}

export class DeleteTimesheetSuccess implements Action {
    readonly type = WorkspaceActionTypes.DELETE_TIMESHEET_SUCCESS;
    constructor(public payload: Model.TimeSheet) {}
}

export class LoadSums implements Action {
    readonly type = WorkspaceActionTypes.LOAD_SUMS;
}

export class SetView implements Action {
    readonly type = WorkspaceActionTypes.SET_VIEW;
    constructor(public payload: Model.View) {}
}

export class LoadUnsubmittedSummary implements Action {
    readonly type = WorkspaceActionTypes.LOAD_UNSUBMITTED_SUMMARY;
}

export class SetUnsubmittedSummaryRows implements Action {
    readonly type = WorkspaceActionTypes.SET_UNSUBMITTED_SUMMARY_ROWS;
    constructor(public payload: TimeSummaryRow[]) {}
}

export class SetSummaryRows implements Action {
    readonly type = WorkspaceActionTypes.SET_SUMMARY_ROWS;
    constructor(public payload: any[]) {}
}

export class SubmitSummaryRow implements Action {
    readonly type = WorkspaceActionTypes.SUBMIT_SUMMARY_ROW;
    constructor(public payload: TimeSummaryRow) {}
}

export class UpdateSummaryRow implements Action {
    readonly type = WorkspaceActionTypes.UPDATE_SUMMARY_ROW;
    constructor(public payload: {before: Model.TimeSummaryRow; after: Model.TimeSummaryRow}) {}
}

export class UndoSummaryRow implements Action {
    readonly type = WorkspaceActionTypes.UNDO_SUMMARY_ROW;
    constructor(public payload: number) {}
}

export class LoadSummaries implements Action {
    readonly type = WorkspaceActionTypes.LOAD_SUMMARIES;
}

export class LoadPTO implements Action {
    readonly type = WorkspaceActionTypes.LOAD_PTO;
}

export class SetPTO implements Action {
    readonly type = WorkspaceActionTypes.SET_PTO;
    constructor(public payload: Model.PTO) {}
}

export class SelectDateRange implements Action {
    readonly type = WorkspaceActionTypes.SELECT_DATE_RANGE;
    constructor(public payload: Model.DateRangeOutput) {}
}

export class SetLoading implements Action {
    readonly type = WorkspaceActionTypes.SET_LOADING;
    constructor(public payload: boolean) {}
}

export class SetPageSize implements Action {
    readonly type = WorkspaceActionTypes.SET_PAGE_SIZE;
    constructor(public payload: any) {}
}

export class LoadPageSize implements Action {
    readonly type = WorkspaceActionTypes.LOAD_SUMMARIES_PAGE_SIZE;
}

export class SetSummariesPageSize implements Action {
    readonly type = WorkspaceActionTypes.SET_SUMMARIES_PAGE_SIZE;
    constructor(public payload: any) {}
}

export class LoadSummariesPageSize implements Action {
    readonly type = WorkspaceActionTypes.LOAD_SUMMARIES_PAGE_SIZE;
}
export class SetSort implements Action {
    readonly type = WorkspaceActionTypes.SET_SORT;
    constructor(public payload: {sort: SortDescriptor[], view: Model.View}) {}
}

export class AddAlert implements Action {
    readonly type = WorkspaceActionTypes.ADD_ALERT;
    constructor(public payload: Model.Message) {}
}

export class RemoveAlert implements Action {
    readonly type = WorkspaceActionTypes.REMOVE_ALERT;
    constructor(public payload: string) {}
}

export class LoadAlerts implements Action {
    readonly type = WorkspaceActionTypes.LOAD_ALERTS;
}

export class SetStaffList implements Action {
    readonly type = WorkspaceActionTypes.SET_STAFF_LIST;
    constructor(public payload: Model.StaffDTO[]) {}
}

export class SelectStaffForSearch implements Action {
    readonly type = WorkspaceActionTypes.SELECT_STAFF_SEARCH;
    constructor(public payload: Model.StaffDTO) {}
}

export class LoadCategories implements Action {
    readonly type = WorkspaceActionTypes.LOAD_CATEGORIES;
}

export class SetCategories implements Action {
    readonly type = WorkspaceActionTypes.SET_CATEGORIES;
    constructor(public payload: Model.Category[]) {}
}

export class AddCategory implements Action {
    readonly type = WorkspaceActionTypes.ADD_CATEGORY;
    constructor(public payload: Model.Category) {}
}

export class SetCategoriesPageSize implements Action {
    readonly type = WorkspaceActionTypes.SET_CATEGORIES_PAGE_SIZE;
    constructor(public payload: any) {}
}
export class LoadCategoriesPageSize implements Action {
    readonly type = WorkspaceActionTypes.LOAD_CATEGORIES_PAGE_SIZE;
}

export class AddDescription implements Action {
    readonly type = WorkspaceActionTypes.ADD_DESCRIPTION;
    constructor(public payload: Model.Description) {}
}

export class SetDescriptionsPageSize implements Action {
    readonly type = WorkspaceActionTypes.SET_DESCRIPTIONS_PAGE_SIZE;
    constructor(public payload: any) {}
}
export class LoadDescriptionsPageSize implements Action {
    readonly type = WorkspaceActionTypes.LOAD_DESCRIPTIONS_PAGE_SIZE;
}

export class UpdateDescription implements Action {
    readonly type = WorkspaceActionTypes.UPDATE_DESCRIPTION;
    constructor(public payload: Model.Description) {}
}

export class SelectCategoryForSearch implements Action {
    readonly type = WorkspaceActionTypes.SELECT_CATEGORY_FOR_SEARCH;
    constructor(public payload: Model.Category) {}
}

export class SetClientsPageSize implements Action {
    readonly type = WorkspaceActionTypes.SET_CLIENTS_PAGE_SIZE;
    constructor(public payload: any) {}
}

export class LoadClientsPageSize implements Action {
    readonly type = WorkspaceActionTypes.LOAD_CLIENTS_PAGE_SIZE;
}

export class DeleteClient implements Action {
    readonly type = WorkspaceActionTypes.DELETE_CLIENT;
    constructor(public payload: Model.ClientDTO) {}
}

export class AddClient implements Action {
    readonly type = WorkspaceActionTypes.ADD_CLIENT;
    constructor(public payload: Model.ClientDTO) {}
}

export class UpdateClient implements Action {
    readonly type = WorkspaceActionTypes.UPDATE_CLIENT;
    constructor(public payload: Model.ClientDTO) {}
}

export class SetStaffPageSize implements Action {
    readonly type = WorkspaceActionTypes.SET_STAFF_PAGE_SIZE;
    constructor(public payload: any) {}
}

export class LoadStaffPageSize implements Action {
    readonly type = WorkspaceActionTypes.LOAD_STAFF_PAGE_SIZE;
}

export class DeleteStaff implements Action {
    readonly type = WorkspaceActionTypes.DELETE_STAFF;
    constructor(public payload: Model.StaffDTO) {}
}

export class AddStaff implements Action {
    readonly type = WorkspaceActionTypes.ADD_STAFF;
    constructor(public payload: Model.StaffDTO) {}
}

export class UpdateStaff implements Action {
    readonly type = WorkspaceActionTypes.UPDATE_STAFF;
    constructor(public payload: Model.StaffDTO) {}
}

export class LoadStaffs implements Action {
    readonly type = WorkspaceActionTypes.LOAD_STAFFS;
}

export class SetStaffs implements Action {
    readonly type = WorkspaceActionTypes.SET_STAFFS;
    constructor(public payload: Model.StaffDTO[]) {}
}

export type WorkspaceActions = SetSearchByDateOption
                            | LoadPayPeriods
                               | SetPayPeriods
                               | SelectPayPeriod
                               | LoadClients
                               | SetClients
                               | SelectClient
                               | SelectStaff
                               | LoadStaff
                               | LoadTimesheets
                               | Search
                               | SetTimesheets
                               | SaveTimesheet
                               | SaveTimesheetSuccess
                               | SetDescriptions
                               | LoadDescriptions
                               | SendMessage
                               | RemoveMessage
                               | DeleteTimesheet
                               | DeleteTimesheetSuccess
                               | LoadSums
                               | SetView
                               | LoadUnsubmittedSummary
                               | SetUnsubmittedSummaryRows
                               | SetSummaryRows
                               | SubmitSummaryRow
                               | UpdateSummaryRow
                               | UndoSummaryRow
                               | LoadSummaries
                               | LoadPTO
                               | SetPTO
                               | SelectDateRange
                               | SetLoading
                               | SetPageSize
                               | LoadPageSize
                               | SetSummariesPageSize
                               | LoadSummariesPageSize
                               | SetSort
                               | AddAlert
                               | RemoveAlert
                               | LoadAlerts
                               | SetStaffList
                               | SelectStaffForSearch
                               | SetSelectedStaffID
                               | LoadCategories
                               | SetCategories
                               | AddCategory
                               | SetCategoriesPageSize
                               | LoadCategoriesPageSize
                               | AddDescription
                               | SetDescriptionsPageSize
                               | LoadDescriptionsPageSize
                               | UpdateDescription
                               | SelectCategoryForSearch
                               | SetClientsPageSize
                               | LoadClientsPageSize
                               | DeleteClient
                               | AddClient
                               | UpdateClient
                               | SetStaffPageSize
                               | LoadStaffPageSize
                               | DeleteStaff
                               | AddStaff
                               | UpdateStaff
                               | LoadStaffs
                               | SetStaffs
                               | LoadStaffCodes
                               | SetStaffCodes;
